import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export class FeedbackBox extends React.Component {
  render() {
    const { title, subTitle, icon } = this.props;
    return (
      <div className="feedback-box mt-4 flex items-center bg-light md:mr-3">
        <div className="circle ml-2 rounded-full bg-orange-400">
          <i className={classnames('icon', icon, 'text-white')} />
        </div>
        <div className="flex flex-col pl-3">
          <div className="text-label">{title}</div>
          <div>{subTitle}</div>
        </div>
      </div>
    );
  }
}

FeedbackBox.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
};

FeedbackBox.defaultProps = {
  title: null,
  subTitle: null,
  icon: null,
};
